import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PaymentCollectionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPaymentCollection = (data): any => action(types.CREATE_PAYMENT_COLLECTION_REQUESTED, data);

export const updatePaymentCollection = (data): any => action(types.UPDATE_PAYMENT_COLLECTION_REQUESTED, data);

export const deletePaymentCollection = (paymentCollectionId): any => action(types.UPDATE_PAYMENT_COLLECTION_REQUESTED, paymentCollectionId);

export const getPaymentCollection = (paymentCollectionId): any => action(types.GET_PAYMENT_COLLECTION_REQUESTED, paymentCollectionId);

export const getAllPaymentCollections = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYMENT_COLLECTIONS_REQUESTED, { pagination, compile });

export const selectPaymentCollection = (paymentCollectionId): any => action(types.SELECT_PAYMENT_COLLECTION_REQUESTED, {
  currentPaymentCollectionId: paymentCollectionId,
});

export const clearPaymentCollections = (): any => action(types.CLEAR_PAYMENT_COLLECTIONS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPaymentCollectionPending: (payload): any => action(types.CREATE_PAYMENT_COLLECTION_PENDING, payload),
  createPaymentCollectionSuccess: (response): any => action(types.CREATE_PAYMENT_COLLECTION_SUCCESS, {
    paymentCollectionsById: response.entities.paymentCollections,
    currentPaymentCollectionId: response.result,
  }),
  updatePaymentCollectionPending: (payload): any => action(types.UPDATE_PAYMENT_COLLECTION_PENDING, payload),
  updatePaymentCollectionSuccess: (response): any => action(types.UPDATE_PAYMENT_COLLECTION_SUCCESS, {
    paymentCollectionsById: response.entities.paymentCollections,
    currentPaymentCollectionId: response.result,
  }),
  updatePaymentCollectionFailed: (error): any => action(types.UPDATE_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
  deletePaymentCollectionPending: (): any => action(types.UPDATE_PAYMENT_COLLECTION_PENDING, {}),
  deletePaymentCollectionSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPaymentCollectionId: null });
    history.push('/paymentCollections');

    return action(types.DELETE_PAYMENT_COLLECTION_SUCCESS, {
      currentPaymentCollectionId: response,
    });
  },
  getPaymentCollectionPending: (): any => action(types.GET_PAYMENT_COLLECTION_PENDING, {}),
  getPaymentCollectionSuccess: (response): any => action(types.GET_PAYMENT_COLLECTION_SUCCESS, {
    paymentCollectionsById: response.entities.paymentCollections,
    currentPaymentCollectionId: response.result,
  }),
  getPaymentCollectionFailed: (error): any => action(types.GET_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
  deletePaymentCollectionFailed: (error): any => action(types.UPDATE_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
  getAllPaymentCollectionsPending: (pagination): any => action(types.GET_ALL_PAYMENT_COLLECTIONS_PENDING, { pagination }),
  getAllPaymentCollectionsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENT_COLLECTIONS_SUCCESS, {
    paymentCollectionsById: response.entities.paymentCollections,
    paymentCollectionIds: response.result,
    meta,
  }),
  getAllPaymentCollectionsFailed: (error): any => action(types.GET_ALL_PAYMENT_COLLECTIONS_FAIL, { backendErrors: error }),
  createPaymentCollectionFailed: (error): any => action(types.CREATE_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
};

export default {
  createPaymentCollection,
  updatePaymentCollection,
  deletePaymentCollection,
  getPaymentCollection,
  getAllPaymentCollections,
  selectPaymentCollection,
};
